import { useSetAtom } from "jotai";
import { useExpensesState } from "atoms/expensesAtom";
import {
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { useDeleteArticle } from "./api";

export const ExpensesFooter = (): JSX.Element => {
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const closeModal = useSetAtom(setModalCloseAtom);
  const { expensesState, setExpensesState } = useExpensesState();

  const { mutate: deleteArticle } = useDeleteArticle();

  const onConfirm = () => {
    deleteArticle(expensesState.activeItem?.articleid || "");
    closeModal();
  };

  const handleDeleteClick = () => {
    if (!expensesState.activeItem) return;

    setConfirmationModal({
      title: `Вы действительно хотите удалить статью затрат "${expensesState.activeItem.name}"?`,
      onConfirm,
    });
  };

  const handleAddClick = () => {
    setExpensesState({ activeItem: null });
  };

  return (
    <div className="flex flex-row ">
      <Button icon="plus" onClick={handleAddClick} />
      <HorizontalSpace size={11} />
      <Button
        icon="delete"
        onClick={handleDeleteClick}
        disabled={!expensesState.activeItem}
      />
    </div>
  );
};
